/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {APP_SHARED} from '../../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED],
  selector: 'adn-custom-event-type-label',
  template: `{{ ('customEvent.type.' + type) | ogTranslate }}`
})
export class CustomEventTypeLabelComponent {
  @Input() type: string;
}
